import $ from "jquery";
import "magnific-popup";

//Properties
const $defaultPopup = $(".js-magnific-popup");

const $videoPopup = $(".js-magnific-popup-video");

const $brightcovePopup = $(".js-magnific-popup-brightcove");

const $iframePopup = $(".js-magnific-popup-iframe");

const $imagePopup = $(".js-magnific-popup-image");

let inlinePopupOptions = {

	closeBtnInside: true,
	prependTo: "body",
	removalDelay: 500, //delay removal by X to allow out-animation
	callbacks: {
		beforeOpen: function () {
			this.st.iframe.markup = this.st.iframe.markup.replace('mfp-iframe-scaler', 'mfp-iframe-scaler mfp-with-anim');
			this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
			this.st.mainClass = this.st.el.attr("data-effect");
		},
		close: function () {
			this.content.removeClass("success");
		}
	},
	midClick: true,
	closeOnBgClick: false,
	fixedContentPos: true
};

let defaultPopupOptions = $.extend({
	type: "inline"
}, inlinePopupOptions);

let iframePopupOptions = $.extend({
	type: "iframe",
	iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>', 

		patterns: {
			youtube_short: {
				index: 'youtu.be/',
				id: 'youtu.be/',
				src: '//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=1&showinfo=0&controls=1&rel=0&ytp-pause-overlay=0&mute=1'
			},
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=1&showinfo=0&controls=1&rel=0&ytp-pause-overlay=0&mute=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			},
			gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			}
		},
		srcAction: 'iframe_src',
	}
}, inlinePopupOptions);

let imagePopupOptions = $.extend({
	type: "image",
	image: {
		titleSrc: "data-description"
	}
}, inlinePopupOptions);

let brightcovePopupOptions = {
	closeBtnInside: true,
	prependTo: "#aspnetForm",
	removalDelay: 500, //delay removal by X to allow out-animation
	callbacks: {
		beforeOpen: function () {
			this.st.iframe.markup = this.st.iframe.markup.replace('mfp-iframe-scaler', 'mfp-iframe-scaler mfp-with-anim');
			this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
			this.st.mainClass = this.st.el.attr("data-effect");
		},
		open: function () {
			var vid = this.content.find(".js-brightcove-video > video");
			if (vid) {
				vid.get(0).play();
			}
		},
		close: function () {
			this.content.removeClass("success");

			var vid = this.content.find(".js-brightcove-video > video");
			if (vid) {
				vid.get(0).pause();
			}
		}
	},
	midClick: true
};

//Methods
const open = (markup) => {
	$.magnificPopup.open({
		items: {
			src: "<div class='popup mfp-with-anim'>" + markup + "</div>",
			type: "inline",
			closeBtnInside: true,
			preloader: true,
			prependTo: "#form",
			removalDelay: 500, //delay removal by X to allow out-animation
			callbacks: {
				beforeOpen: function () {
					this.st.mainClass = this.st.el.attr("data-effect");
				},
				close: function () {
					this.content.removeClass("success");
				}
			},
			midClick: true
		}
	});
}

const initEvents = () => {

	$(document).on("click", triggerPopupClick);

}

const triggerPopupClick = (e) => {

	e.preventDefault();

	const ele = e.currentTarget,
		$this = $(ele);

	let popupValue = $this.attr("data-popup");

	let popupHtml = popupValue;

	let $popupElement = $(popupValue);

	if ($popupElement.length) {
		popupHtml = $popupElement[0].outerHTML;
	}

	open(popupHtml);
}

//Execution

let init = () => {

	//initEvents();

	

	$defaultPopup.length > 0 ? $defaultPopup.magnificPopup(defaultPopupOptions) : null;

	$videoPopup.length > 0 ? $videoPopup.magnificPopup(iframePopupOptions) : null;

	$brightcovePopup.length > 0 ? $brightcovePopup.magnificPopup(brightcovePopupOptions) : null;

	$iframePopup.length > 0 ? $iframePopup.magnificPopup(iframePopupOptions) : null;

	$imagePopup.length > 0 ? $imagePopup.magnificPopup(imagePopupOptions) : null;


	console.log($iframePopup.length);

}

export let magnificPopup = {
	init: init,
	open: open
}